module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.2b4910bf.ttf";